export const consumptionMilestones = [ 100, 90, 80, 70 ] as const;
export type ConsumptionMilestone = typeof consumptionMilestones[number];
